import { localStorageHelpers } from "utils/helpers/localStorage";

type AuthInLocalStorageProps = {
  token: string;
  refreshToken: string;
  keepMe: boolean;
};

export const user_token_key = "userToken";
export const user_refreshToken_key = "refreshToken";
export const user_keepMe_key = "keepMe";

//token
export const setTokenInLocalStorage = (value: string) => {
  localStorageHelpers.setItemInLocalStorage(user_token_key, value);
};

export const removeTokenFromLocalStorage = () => {
  localStorageHelpers.removeItemFromLocalStorage(user_token_key);
};

export const getTokenFromLocalStorage = () => {
  return localStorageHelpers.getItemFromLocalStorage(user_token_key);
};

//refreshtoken
export const getRefreshTokenFromLocalStorage = () => {
  return localStorageHelpers.getItemFromLocalStorage(user_refreshToken_key);
};

export const setRefreshTokenInLocalStorage = (value: string) => {
  localStorageHelpers.setItemInLocalStorage(user_refreshToken_key, value);
};

export const removeRefreshTokenFromLocalStorage = () => {
  localStorageHelpers.removeItemFromLocalStorage(user_refreshToken_key);
};

//keep me
export const setKeepMeInLocalStorage = (value: boolean) => {
  localStorageHelpers.setItemInLocalStorage(user_keepMe_key, `${value}`);
};

export const getKeepMeFromLocalStorage = () => {
  return localStorageHelpers.getItemFromLocalStorage(user_keepMe_key);
};

export const removekeepMeFromLocalStorage = () => {
  localStorageHelpers.removeItemFromLocalStorage(user_keepMe_key);
};

//auth
export const authLocalStorage = (data: AuthInLocalStorageProps) => {
  setTokenInLocalStorage(data.token);
  setRefreshTokenInLocalStorage(data.refreshToken);
};

export const removeAuthFromLocalStorage = () => {
  removeTokenFromLocalStorage();
  removeRefreshTokenFromLocalStorage();
  removekeepMeFromLocalStorage();
};
